import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { PriceMenu } from "@/components/site/PriceMenu";
import { PriceCalculator } from "@/components/site/PriceCalculator";
import { Gallery } from "@/components/site/Gallery";
import { Gifts } from "@/components/site/Gifts";
import { Reviews } from "@/components/site/Reviews";
import { FAQ } from "@/components/site/FAQ";
import { EnquiryForm } from "@/components/site/EnquiryForm";
import { PaymentLinks } from "@/components/site/PaymentLinks";
import { Footer } from "@/components/site/Footer";
import { ChatAssistant } from "@/components/site/ChatAssistant";
import { WhatsAppButton } from "@/components/site/WhatsAppButton";

export default function Home() {
  return (
    <main>
      <Navbar />
      <Hero />
      <Marquee />
      <PriceMenu />
      <PriceCalculator />
      <Gallery />
      <Gifts />
      <Reviews />
      <FAQ />
      <EnquiryForm />
      <PaymentLinks />
      <Footer />
      <WhatsAppButton />
      <ChatAssistant />
    </main>
  );
}
